













import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class Card extends Vue {
  @Prop({ default: '' }) size;
  @Prop({ default: false }) closable;
  @Prop({ default: '/login' }) navigateToAfterClose;
  get classNames() {
    if (this.size === 'xl') {
      return 'col-md-9 col-lg-8';
    }
    return 'col-md-6 col-lg-5';
  }
}
